import { render, staticRenderFns } from "./memberBinding.vue?vue&type=template&id=1a27e0b2&scoped=true&"
import script from "./memberBinding.vue?vue&type=script&lang=js&"
export * from "./memberBinding.vue?vue&type=script&lang=js&"
import style0 from "./memberBinding.vue?vue&type=style&index=0&id=1a27e0b2&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1a27e0b2",
  null
  
)

export default component.exports